<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search...(case-sensitive)"
                    >
                    </base-input>
                    <base-input label="Filter by Hub Manager" class="mx-4">
                        <el-select
                            v-model="filterManager"
                            multiple
                            placeholder="Select Manager"
                            >
                            <el-option
                                v-for="item in hubManagers"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col cols="12" md="3" >
                    <b-button class="float-right px-3 py-2" variant="outline-secondary" disabled>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <div class="table-listings">
            <el-table
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                empty-text="No Data"
                @selection-change="selectionChange"
                v-loading="isTableLoading"
            >
                <el-table-column
                    type="selection"
                    width="55"
                ></el-table-column>

                <el-table-column
                    prop="hub_name"
                    label="Name/ID"
                    min-width="200"
                    fixed
                    sortable
                >
                    <template slot-scope="scope">
                            <router-link :to="'/hubProfileDetails/'+scope.row.hub_id" class="name font-weight-500 text-primary mb-0">
                                {{ scope.row.hub_name }}
                            </router-link><br>
                        <small>{{ scope.row.hub_id }}</small>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="total_cases"
                    label="Total Cases"
                    min-width="150"
                    sortable
                >
                    <template slot-scope="scope" >
                            <svg id="cases-svg" width="50" height="50">
                                <circle cx="25" cy="25" r="18" stroke="#5d79e3" stroke-width="2" fill="#dce2f9" />
                                <text x="25" y="30" text-anchor="middle" fill="#5d79e3" class="cases-text">{{ scope.row.total_cases.all || '0' }}</text>
                            </svg>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="total_actual_rev"
                    label="Actual KPI Progress (RM)"
                    min-width="260"
                    sortable
                >
                    <template slot-scope="scope">
                        <span class="mb-0 top-line">{{ scope.row.total_actual_rev || 0 | moneyFormatter }} ({{ scope.row.total_actual_rev / scope.row.total_target * 100 || '0' | moneyFormatter }}%)/ <span class="text-muted">{{ scope.row.total_target | moneyFormatter }}</span></span>
                        <b-progress height="7px" :value="scope.row.total_actual_rev / scope.row.hub_target * 100" :max="100.00" class="w-100" variant="success"></b-progress>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="total_pre_rev"
                    label="Total Pre-Rev. (RM)"
                    min-width="200"
                    sortable
                >
                    <template slot-scope="scope">
                        <span class="mx-2 font-weight-bold">{{ scope.row.total_pre_rev || 0 | moneyFormatter }}</span>
                        <el-tooltip placement="bottom" effect="light">
                            <div slot="content">
                                custom tooltip
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512"><path class="text-primary" fill="currentColor" d="M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56Zm0 82a26 26 0 1 1-26 26 26 26 0 0 1 26-26Zm48 226h-88a16 16 0 0 1 0-32h28v-88h-16a16 16 0 0 1 0-32h32a16 16 0 0 1 16 16v104h28a16 16 0 0 1 0 32Z"/></svg>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Team Members"
                    min-width="185"
                >
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.team_members.length > 0" placement="bottom" effect="light">
                            <div slot="content" class="table-tooltip">
                                <p v-for="member in scope.row.team_members" :key="member.id" class="mb-0">
                                    Name: <b>{{ member.name }}</b>
                                </p>
                            </div>
                            <b-avatar-group v-if="scope.row.team_members.length > 0" size="2.5rem" overlap="0.2">
                                <b-avatar v-for="member in scope.row.team_members.slice(0, 3)" :key="member.id" :src="member.avatar_url" :text="getInitials(member.name)"></b-avatar>
                                <b-avatar v-if="scope.row.team_members.length > 3" :key="scope.row.team_members.id" variant="secondary">{{ '+' + (scope.row.team_members.length - 3) }}</b-avatar>
                            </b-avatar-group>
                        </el-tooltip>
                        <div v-else>
                            <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Team Leaders"
                    min-width="185"
                >
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.team_leaders.length > 0" placement="bottom" effect="light">
                            <div slot="content" class="table-tooltip">
                                <p v-for="member in scope.row.team_leaders" :key="member.id" class="mb-0">
                                    Name: <b>{{ member.name }}</b>
                                </p>
                            </div>
                            <b-avatar-group v-if="scope.row.team_leaders.length > 0" size="2.5rem" overlap="0.2">
                                <b-avatar v-for="member in scope.row.team_leaders.slice(0, 3)" :key="member.id" :src="member.avatar_url" :text="getInitials(member.name)"></b-avatar>
                                <b-avatar v-if="scope.row.team_leaders.length > 3" :key="scope.row.team_leaders.id" variant="secondary">{{ '+' + (scope.row.team_leaders.length - 3) }}</b-avatar>
                            </b-avatar-group>
                        </el-tooltip>
                        <div v-else>
                            <span style="font-size: 1.5rem">-</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="hub_manager.name"
                    label="Hub Manager"
                    min-width="170"
                    sortable
                >
                    <template slot-scope="scope">
                        <span class="text-break">{{ scope.row.hub_manager.name }}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="total_balance_payout"
                    label="Total Payout/Pool(Tokens)"
                    min-width="270"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.total_balance_payout || 0 | moneyFormatter }}</p>
                        <span class="mb-0 bottom-line">{{ scope.row.total_pool_payout || 0 | moneyFormatter }}</span>&nbsp;
                        <span class="mb-0 bottom-line">({{ scope.row.hub_tokens || 0 }} Tokens)</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="created_at"
                    label="Created/Updated"
                    min-width="190"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.created_at | dateFormatString }}</p>
                        <p class="mb-0 bottom-line">{{ scope.row.updated_at | dateFormatFromNow }}</p>
                    </template>
                </el-table-column>


            </el-table>
        </div>
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Tooltip } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { axios, services, getHeader,debounce } from '@/assets/js/httpImports.js'
import { EventBus } from '../../../main'

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
    },
    data() {
        return {
            isTableLoading: true,
            propsToSearch:['name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            tableData: [],
            tableDataMock: [
                {
                    hub_id: 'H0001',
                    hub_name:  'Hub Skypod',
                    total_cases: 48,
                    actual_kpi_progress: 1400000.00,
                    hub_target: 2000000.00,
                    percentage_kpi_progress:  70.34,
                    total_pre_rev: 700000.00,
                    team_leaders: [
                        {
                            name: 'Kunalan',
                            avatar_url: 'https://placekitten.com/300/302'
                        },
                        {
                            name: 'Teong Kim',
                            avatar_url: 'https://placekitten.com/300/320'
                        },
                        {
                            name: 'Hwang Yeji',
                            avatar_url: 'https://placekitten.com/300/308'
                        },
                    ],
                    team_members: [
                        {
                            id: 32,
                            name: 'Jason Chen',
                            avatar_url: 'https://placekitten.com/300/300'
                        },
                        {
                            id: 23,
                            name: 'Maya Higa',
                            avatar_url: 'https://placekitten.com/300/312'
                        },
                        {
                            id: 554,
                            name: 'Thanusha Xavierkumar',
                            avatar_url: 'https://placekitten.com/300/307'
                        },
                        {
                            id: 543,
                            name: 'Nathan Lee',
                        },
                        {
                            id: 678,
                            name: 'Linda Nguyen',
                        }
                    ],
                    hub_manager: 'Derrick Teh',
                    total_payout: 1190000.00,
                    pool: 210000.00,
                    hub_tokens: 10,
                    created_at: '23 Nov, 2022',
                    updated_at: '3 days ago'
                }
            ],
            filterManager: '',
            hubManagers: [{
                    value: 'Mena',
                    label: 'Mena'
                }, {
                    value: 'Vincent',
                    label: 'Vincent'
                }
            ]
        }
    },
    created() {
        this.getHubList();
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
        EventBus.$on('refresh-hub-list', (res) => {
            this.getnewHubList(res)
        });
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getHubList() {
            this.isTableLoading = true
            axios.get(services.hub + 'hubs', { headers: getHeader() })
            .then(response => {
                this.isTableLoading = false
                this.tableData = response.data.data
            })
            .catch ( error => {
                this.isTableLoading = false
                this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message) 
            });
        },
        getInitials(name) {
            const names = name.split(' ');
            let initials = '';
            const maxInitials = 3;
            for (let i = 0; i < names.length && i < maxInitials; i++) {
                initials += names[i].charAt(0);
            }
            return initials;
        },
        getnewHubList(res) {
            this.tableData.push(res.data.data)
        }
    }
}
</script>